import React, { useEffect, useState } from 'react';

const Timer = (
    { stopFlag, stopCallback }: { stopFlag: boolean, stopCallback: Function }
) => {
    const [minutes, setMinutes] = useState<number>(0);
    const [seconds, setSeconds] =  useState<number>(0);

    useEffect(() => {
        let timer = setInterval(() => {
            if (stopFlag) {
                clearInterval(timer);
                stopCallback(minutes, seconds);
                return;
            }
            if (seconds >= 59) {
                setSeconds(0);
                setMinutes(minutes + 1);
            } else {
                setSeconds(seconds + 1);
            }
        }, 1000);
        return () => clearInterval(timer);
    });

    return <span>{('00' + minutes).slice(-2)} : {('00' + seconds).slice(-2)}</span>;
};

export default Timer;
